import {
	Backdrop,
	Button,
	Divider,
	Fade,
	Grid,
	makeStyles,
	Modal,
	TextField,
	Typography,
} from "@material-ui/core";
import { useSnackbar } from "notistack";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { config as url } from "../../../common/config";
import authContext from "../../../context/Auth/authContext";
import FetchDataContext from "../../../context/fetchData/fetchDataContext";
import AlertNotistack from "../AlertNotistack";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "center",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "0.125rem solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2),
		borderRadius: 5,
		marginTop: "4.688rem",
	},
	form: {
		flexBasis: "700px",
		[theme.breakpoints.down("sm")]: {
			paddingLeft: theme.spacing(2),
			paddingRight: theme.spacing(2),
		},
		position: "relative",
	},
	fields: {
		marginTop: theme.spacing(0),
	},
	textField: {
		width: "100%",
		"& + & ": {
			marginTop: theme.spacing(1.5),
		},
	},
	title: {
		marginBottom: theme.spacing(1),
		color: theme.palette.primary.main,
	},
	alert: {
		marginBottom: theme.spacing(2),
	},
	button: {
		marginTop: theme.spacing(2),
		width: "22.25%",
		marginLeft: theme.spacing(2),
	},
	buttonClose: {
		marginTop: theme.spacing(2),
		width: "22.25%",
		backgroundColor: theme.palette.error.main,
		"&:hover": {
			backgroundColor: theme.palette.error.dark,
		},
	},
	selectEmpty: {
		marginTop: theme.spacing(2),
	},
}));

const EditProfile = ({ open, handleCloseModal }) => {
	const { enqueueSnackbar } = useSnackbar();
	const classes = useStyles();
	const BaseUrl = `${url.users}`;
	const fetchData = useContext(FetchDataContext);
	const { updateData } = fetchData;
	const { register, handleSubmit, errors, clearErrors } = useForm();

	const AuthContext = useContext(authContext);
	const { user, loadUserInfo } = AuthContext;

	const [state, setState] = useState({
		id: "",
		nama_user: "",
		username: "",
		email: "",
		phone: "",
	});

	const { username, nama_user, email, phone } = state;

	const handleSubmits = () => {
		return false;
	};

	const onSubmit = async (item) => {
		if (validateEmail(item.email)) {
			await editData(state);
		} else {
			return enqueueSnackbar("Email Tidak Valid", AlertNotistack("error"));
		}
	};

	const editData = async (data) => {
		const result = await updateData(
			`${BaseUrl}/change/profile?id=${data.id}`,
			data,
			handleSubmits
		);
		if (result.status === "success") {
			setTimeout(() => {
				closeModal();
				loadUserInfo();
			}, 2000);
		}
		return result;
	};

	const handleFieldChange = (e) => {
		setState({ ...state, [e.target.name]: e.target.value });
	};

	const validateEmail = (email) => {
		const re =
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	};

	const closeModal = () => {
		setState({
			...state,
			id: user.id,
			nama_user: user.nama_user,
			username: user.username,
			email: user.email,
			phone: user.phone,
		});
		handleCloseModal();

		clearErrors();
	};

	useEffect(() => {
		if (user) {
			setState({
				id: user.id,
				nama_user: user.nama_user,
				username: user.username,
				email: user.email,
				phone: user.phone,
			});
		}
	}, [user]);

	return (
		<Grid>
			<Modal
				disablePortal
				disableEnforceFocus
				disableAutoFocus
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={closeModal}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={open}>
					<Grid
						item
						xl={3}
						lg={4}
						md={5}
						sm={6}
						xs={11}
						className={classes.paper}
					>
						<Typography className={classes.title} variant="h4">
							Edit Profile
						</Typography>
						<Divider />
						<Typography className={classes.alert}></Typography>
						<form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
							<Grid className={classes.fields}>
								<TextField
									className={classes.textField}
									label="Username"
									name="username"
									onChange={handleFieldChange}
									type="text"
									value={username}
									variant="outlined"
									autoComplete="off"
									disabled
									required
								/>
								<TextField
									className={classes.textField}
									label="Nama User"
									name="nama_user"
									onChange={handleFieldChange}
									type="text"
									value={nama_user}
									variant="outlined"
									autoComplete="off"
									required
								/>
								<TextField
									className={classes.textField}
									label="Email"
									name="email"
									onChange={handleFieldChange}
									type="email"
									value={email}
									error={errors.email}
									variant="outlined"
									autoComplete="off"
									inputRef={register()}
									InputLabelProps={{ shrink: true }}
									helperText={errors.email && errors.email.message}
									required
								/>
								<TextField
									className={classes.textField}
									id="phone"
									name="phone"
									label="Phone Number"
									onChange={handleFieldChange}
									value={phone}
									error={errors.phone}
									variant="outlined"
									autoComplete="off"
									placeholder="Type your Phone Number"
									type="number"
									inputRef={register({
										minLength: {
											value: 10,
											message: "Minimal length phone number 10",
										},
										maxLength: {
											value: 14,
											message: "Maximal length phone number 14",
										},
									})}
									required
									helperText={errors.phone && errors.phone.message}
								/>
							</Grid>
							<Divider style={{ marginTop: "1rem" }} />
							<Grid style={{ display: "flex", flexDirection: "row-reverse" }}>
								<Button
									className={classes.button}
									color="primary"
									type="submit"
									size="large"
									variant="contained"
								>
									Save
								</Button>
								<Button
									className={classes.buttonClose}
									size="large"
									variant="contained"
									onClick={closeModal}
								>
									Close
								</Button>
							</Grid>
						</form>
					</Grid>
				</Fade>
			</Modal>
		</Grid>
	);
};

export default EditProfile;
